import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '@/i18n';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface LanguageSelectorProps {
  variant?: 'compact' | 'full';
}

export function LanguageSelector({ variant = 'full' }: LanguageSelectorProps) {
  const { i18n } = useTranslation();

  return (
    <Select value={i18n.language} onValueChange={(value) => i18n.changeLanguage(value)}>
      <SelectTrigger className={variant === 'compact' ? 'w-[70px]' : 'w-[180px]'}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {supportedLanguages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {variant === 'compact' ? lang.code.toUpperCase() : lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
